import toast from "react-hot-toast";
import { FiCopy } from "react-icons/fi";

interface CopyLinkButtonProps {
  url: string;
}

export function CopyLinkButton({ url }: CopyLinkButtonProps) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(
        <div>
          <p className="font-medium">Copied!</p>
          <p className="text-sm text-gray-600 truncate max-w-xs">{url}</p>
        </div>,
        { duration: 3000 }
      );
    } catch {
      toast.error("Failed to copy link");
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="text-blue-600 hover:text-blue-800 transition-colors ml-2"
      title="Copy link"
      aria-label="Copy link to clipboard"
    >
      <FiCopy className="h-4 w-4" />
    </button>
  );
}
